<template>
  <section >
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :is-full-page="false"
        :background-color="bgColor"
        :opacity="opacity"
      ></loading>

      <b-card no-body>
        <b-tabs pills card vertical nav-wrapper-class="w-25" small>
          <b-tab title="Dispatch w/ Storage" active >
            <div>
              <highcharts class="time-chart" ref="highcharts" :options="chartOptionsOneStorage" ></highcharts>
            </div>
          </b-tab>
          <b-tab title="Dispatch No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsOneNoStorage"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr w/ Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsTwo"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsTwoNoStorage"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr/Person w/ Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsFive"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr/Person No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsFiveNoStorage"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr/GDP w/ Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsSix"></highcharts>
            </div>
          </b-tab>
          <b-tab title="$/yr/GDP No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsSixNoStorage"></highcharts>
            </div>
          </b-tab>
          <b-tab title="CO2/year w/ Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsThree"></highcharts>
            </div>
          </b-tab>
          <b-tab title="CO2/year No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsThreeNoStorage"></highcharts>
            </div>
          </b-tab>
          <b-tab title="Capacity w/ Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsFour"></highcharts>
            </div>
          </b-tab>
          <b-tab title="Capacity No Storage">
            <div>
              <highcharts class="time-chart" :options="chartOptionsFourNoStorage"></highcharts>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      
      <br />
      <p class="right">©<span id="currentYear"></span> UT Energy Institute</p>
    </div>
  </section>
</template>


<script>
import { Chart } from 'highcharts-vue';
import JQuery from 'jquery';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters, mapActions, mapState } from 'vuex';

let $ = JQuery;

export default {
  name: 'Time',
  props: ['timeData', 'timeDataNoStorage', 'moneyData', 'moneyDataNoStorage', 
    'emissionsData', 'emissionsDataNoStorage', 'capacityData', 'capacityDataNoStorage', 'isLoading'],
  components: {
    highcharts: Chart,
    Loading
  },
  methods: {
    ...mapActions(['toggleStorage']),

    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      $('.time-chart').css('width', this.windowWidth - 1300);
      
      // console.log('test: ', this)
    },

  },
  created() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy: function() {
  },
  mounted() {
    // this.render()
    this.$nextTick(function() {
      window.addEventListener('resize', this.handleWindowResize);

    });

    $('.tabnav ul li').hide();

    var dt = new Date();
    $("#currentYear").html(dt.getFullYear());

    this.loading = true;
    // simulate AJAX
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
  watch: {
    isLoading() {
      this.loading = this.isLoading
    },
  },
  computed: {
    ...mapGetters(['allMWOutput']),
    ...mapState(['storage', 'timeSeriesMW', 'timeSeries']),
    
    chartOptionsOneNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'Power Plant Generation Per Hour (1 week each season)',
         },
        //  colors: ["#FFFF00","#FF0000","#0000FF","#800080","#A52A2A","#00FFFF","#000000","#00FF00","#008000","#FFA500","#FAAFBE","#FAAFBE","#FAAFBE","#FAAFBE","#C0C0C0","#FFA500","#808080"], 
          xAxis: {
            type: 'datetime',
            min: (500 * 3600000),
            max: (7237 * 3600000),
            plotBands: [{
              color: '#EBF6FB',
              label: {
                text: 'Winter'
              },
              from: 0,
              to: (667 * 3600000)
            },
            {
              color: '#FFFFFF',
              label: {
                text: 'Spring'
              },
              from: (2690 * 3600000),
              to: (2857 *  3600000)
            },
            {
              color: '#EBF6FB',
              label: {
                text: 'Summer'
              },
              from: (4880 * 3600000),
              to: (5047 * 3600000)
            },
            {
              color: '#FFFFFF',
              label: {
                text: 'Fall'
              },
              from: (7070 * 3600000),
              to: (7237 *  3600000)
            },],
            breaks: [{
              // breakSize: 30 * 3600000,
              from: (667 * 3600000),
              to: (2690 * 3600000)
            },
            {
              from: (2857 *  3600000),
              to: (4880 * 3600000)
            },
            {
              from: (5047 * 3600000),
              to: (7070 * 3600000)
            }]
          },
         yAxis: {
           title: {
             text: 'Megawatt'
           },
         },
         tooltip: {
           dateTimeLabelFormats: {
             day: '%b'
           },
           valueDecimals: 0
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           }
         },
        series: this.timeDataNoStorage
      }
    },
    chartOptionsOneStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'Power Plant Generation Per Hour (1 week each season)',
         },
        //  colors: ["#FFFF00","#FF0000","#0000FF","#800080","#A52A2A","#00FFFF","#000000","#00FF00","#008000","#FFA500","#FAAFBE","#FAAFBE","#FAAFBE","#FAAFBE","#C0C0C0","#FFA500","#808080"], 
          xAxis: {
            type: 'datetime',
            min: (500 * 3600000),
            max: (7237 * 3600000),
            plotBands: [{
              color: '#EBF6FB',
              label: {
                text: 'Winter'
              },
              from: 0,
              to: (667 * 3600000)
            },
            {
              color: '#FFFFFF',
              label: {
                text: 'Spring'
              },
              from: (2690 * 3600000),
              to: (2857 *  3600000)
            },
            {
              color: '#EBF6FB',
              label: {
                text: 'Summer'
              },
              from: (4880 * 3600000),
              to: (5047 * 3600000)
            },
            {
              color: '#FFFFFF',
              label: {
                text: 'Fall'
              },
              from: (7070 * 3600000),
              to: (7237 *  3600000)
            },],
            breaks: [{
              // breakSize: 30 * 3600000,
              from: (667 * 3600000),
              to: (2690 * 3600000)
            },
            {
              from: (2857 *  3600000),
              to: (4880 * 3600000)
            },
            {
              from: (5047 * 3600000),
              to: (7070 * 3600000)
            }]
          },
         yAxis: {
           title: {
             text: 'Megawatt'
           },
         },
         tooltip: {
           dateTimeLabelFormats: {
             day: '%b'
           },
           valueDecimals: 0
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           }
         },
        series: this.timeData
      }
    },
    chartOptionsTwo() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '$ Billions'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyData["pp_opex"],
            color: '#F7A93B'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyData["pp_capex"],
            color: '#C97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyData["t_and_d_opex"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyData["t_and_d_capex"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyData["pet_industrial"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyData["pet_commercial"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyData["pet_transport"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyData["pet_res"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyData["ng_industrial"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyData["ng_commercial"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyData["ng_transport"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyData["ng_res"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyData["coal_non_elec"],
            color: '#8c827b'
          },
        ]
      }
    },
    chartOptionsTwoNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '$ Billions'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyDataNoStorage["pp_opex"],
            color: '#F7A93B'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyDataNoStorage["pp_capex"],
            color: '#c97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyDataNoStorage["t_and_d_opex"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyDataNoStorage["t_and_d_capex"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyDataNoStorage["pet_industrial"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyDataNoStorage["pet_commercial"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyDataNoStorage["pet_transport"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyDataNoStorage["pet_res"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyDataNoStorage["ng_industrial"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyDataNoStorage["ng_commercial"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyDataNoStorage["ng_transport"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyDataNoStorage["ng_res"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyDataNoStorage["coal_non_elec"],
            color: '#8c827b'
          },
        ]
      }
    },
    chartOptionsFour() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'Required Capacity to Meet User Scenario',
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: 'Megawatt'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Storage Capacity',
            data: this.capacityData.battery,
            color: 'black'
          },
          {
            name: 'Hydro',
            // type: 'column',
            data: this.capacityData.hydro,
            color: '#3D3BFF'
          },
          {
            name: 'Wind',
            // type: 'column',
            data: this.capacityData.wind,
            color: '#925E95'
          },
          {
            name: 'Solar PV',
            // type: 'column',
            data: this.capacityData.solarPV,
            color: '#FAE059'
          },
          {
            name: 'Solar CSP',
            // type: 'column',
            data: this.capacityData.solarCSP,
            color: '#BCA845'
          },
          {
            name: 'Biomass',
            // type: 'column',
            data: this.capacityData.biomass,
            color: '#A6F2A9'
          },
          {
            name: 'Coal',
            // type: 'column',
            data: this.capacityData.coal,
            color: '#898989'
          },
          {
            name: 'Geothermal',
            // type: 'column',
            data: this.capacityData.geothermal,
            color: '#A87D4C'
          },
          {
            name: 'NGCC',
            // type: 'column',
            data: this.capacityData.ngcc,
            color: '#62BEF7'
          },
          {
            name: 'NGCT',
            // type: 'column',
            data: this.capacityData.ngct,
            color: '#AED7EF'
          },
          {
            name: 'Petroleum',
            // type: 'column',
            data: this.capacityData.petroleum,
            color: '#7AA37B'
          },
          {
            name: 'Nuclear',
            // type: 'column',
            data: this.capacityData.nuclear,
            color: '#D44148'
          },
        ]
      }
    },
    chartOptionsFourNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'Required Capacity to Meet User Scenario',
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: 'Megawatt'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Storage Capacity',
            data: this.capacityDataNoStorage.battery,
            color: 'black'
          },
          {
            name: 'Hydro',
            // type: 'column',
            data: this.capacityDataNoStorage.hydro,
            color: '#3D3BFF'
          },
          {
            name: 'Wind',
            // type: 'column',
            data: this.capacityDataNoStorage.wind,
            color: '#925E95'
          },
          {
            name: 'Solar PV',
            // type: 'column',
            data: this.capacityDataNoStorage.solarPV,
            color: '#FAE059'
          },
          {
            name: 'Solar CSP',
            // type: 'column',
            data: this.capacityDataNoStorage.solarCSP,
            color: '#BCA845'
          },
          {
            name: 'Biomass',
            // type: 'column',
            data: this.capacityDataNoStorage.biomass,
            color: '#A6F2A9'
          },
          {
            name: 'Coal',
            // type: 'column',
            data: this.capacityDataNoStorage.coal,
            color: '#898989'
          },
          {
            name: 'Geothermal',
            // type: 'column',
            data: this.capacityDataNoStorage.geothermal,
            color: '#A87D4C'
          },
          {
            name: 'NGCC',
            // type: 'column',
            data: this.capacityDataNoStorage.ngcc,
            color: '#62BEF7'
          },
          {
            name: 'NGCT',
            // type: 'column',
            data: this.capacityDataNoStorage.ngct,
            color: '#AED7EF'
          },
          {
            name: 'Petroleum',
            // type: 'column',
            data: this.capacityDataNoStorage.petroleum,
            color: '#7AA37B'
          },
          {
            name: 'Nuclear',
            // type: 'column',
            data: this.capacityDataNoStorage.nuclear,
            color: '#D44148'
          },
        ]
      }
    },
    chartOptionsThree() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'CO2 Emissions from Energy',
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: 'Million Metric Tonnes of CO2'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
        
          {
            name: 'Coal',
            data: this.emissionsData["Coal"],
            color: '#898989'
          },
          {
            name: 'Natural Gas',
            data: this.emissionsData["Natural Gas"],
          },
          {
            name: 'Petroleum',
            data: this.emissionsData["Petroleum"],
            color: 'green'
          },
          {
            name: 'Pwr Plant Mfg./Constr',
            data: this.emissionsData["Embodied"],
            color: 'orange'
          }
        ]
      }
    },
    chartOptionsThreeNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: 'CO2 Emissions from Energy',
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: 'Million Metric Tonnes of CO2'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
     
          {
            name: 'Coal',
            data: this.emissionsDataNoStorage["Coal"],
            color: '#898989'
          },
          {
            name: 'Natural Gas',
            data: this.emissionsDataNoStorage["Natural Gas"],
          },
          {
            name: 'Petroleum',
            data: this.emissionsDataNoStorage["Petroleum"],
            color: 'green'
          },
          {
            name: 'Pwr Plant Mfg./Constr',
            data: this.emissionsDataNoStorage["Embodied"],
            color: 'orange'
          }
        ]
      }
    },
    chartOptionsFive() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy (per person)",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '$/person'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyData["all_pp_opex"],
            color: '#f7a93b'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyData["all_pp_capex"],
            color: '#c97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyData["TandD_opex"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyData["TandD_capex"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyData["oil_indus_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyData["oil_commerce_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyData["oil_transport_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyData["oil_resid_spending"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyData["ng_indus_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyData["ng_commerce_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyData["ng_transport_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyData["ng_resid_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyData["coal_not_elec"],
            color: '#8c827b'
          }
        ]
      }
    },
    chartOptionsFiveNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy (per person)",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '$/person'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyDataNoStorage["all_pp_opex"],
            color: '#f7a93b'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyDataNoStorage["all_pp_capex"],
            color: '#c97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyDataNoStorage["TandD_opex"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyDataNoStorage["TandD_capex"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyDataNoStorage["oil_indus_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyDataNoStorage["oil_commerce_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyDataNoStorage["oil_transport_spending"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyDataNoStorage["oil_resid_spending"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyDataNoStorage["ng_indus_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyDataNoStorage["ng_commerce_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyDataNoStorage["ng_transport_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyDataNoStorage["ng_resid_spending"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyDataNoStorage["coal_not_elec"],
            color: '#8c827b'
          }
        ]
      }
    },
    chartOptionsSix() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy (per GDP)",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '%/GDP'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyData["all_pp_opex_GDP"],
            color: '#f7a93b'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyData["all_pp_capex_GDP"],
            color: '#c97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyData["TandD_opex_GDP"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyData["TandD_capex_GDP"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyData["oil_indus_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyData["oil_commerce_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyData["oil_transport_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyData["oil_resid_spending_GDP"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyData["ng_indus_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyData["ng_commerce_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyData["ng_transport_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyData["ng_resid_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyData["coal_not_elec_GDP"],
            color: '#8c827b'
          }
        ]
      }
    },
    chartOptionsSixNoStorage() {
      return {
        credits: {
           enabled: false
         },
         chart: {
           height: 400,
           type: 'area',
           zoomType: 'x'
         },
         title: {
           text: "Spending on Energy (per GDP)",
         },
         xAxis: {
          title: {
            text: 'Year'
          },
          
         },
         tooltip: {
           valueDecimals: 0
         },
         yAxis: {
           title: {
             text: '%/GDP'
           },
         },
         plotOptions: {
           area: {
             stacking: 'normal'
           },
           series: {
             pointStart: 2000
           },
           
         },
        series: [
          {
            name: 'Pwr Plants & Storage (O&M)',
            data: this.moneyDataNoStorage["all_pp_opex_GDP"],
            color: '#f7a93b'
          },
          {
            name: 'Pwr Plants & Storage (capital)',
            data: this.moneyDataNoStorage["all_pp_capex_GDP"],
            color: '#c97d12'
          },
          {
            name: 'Elec. Trans & Dist (O&M)',
            data: this.moneyDataNoStorage["TandD_opex_GDP"],
            color: '#f28b79'
          },
          {
            name: 'Elec. Trans & Dist (capital)',
            data: this.moneyDataNoStorage["TandD_capex_GDP"],
            color: 'red'
          },
          {
            name: 'Petroleum (industrial)',
            data: this.moneyDataNoStorage["oil_indus_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (commercial)',
            data: this.moneyDataNoStorage["oil_commerce_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (transportation)',
            data: this.moneyDataNoStorage["oil_transport_spending_GDP"],
            color: 'green'
          },
          {
            name: 'Petroleum (residential)',
            data: this.moneyDataNoStorage["oil_resid_spending_GDP"],
            color: 'green'
          },
          {
            name: 'NG (industrial)',
            data: this.moneyDataNoStorage["ng_indus_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (commercial)',
            data: this.moneyDataNoStorage["ng_commerce_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (transportation)',
            data: this.moneyDataNoStorage["ng_transport_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'NG (residential)',
            data: this.moneyDataNoStorage["ng_resid_spending_GDP"],
            color: '#7dd1f2'
          },
          {
            name: 'Coal (non-electricity)',
            data: this.moneyDataNoStorage["coal_not_elec_GDP"],
            color: '#8c827b'
          }
        ]
      }
    }
  },
  data() {
    // const that = this;
    return {
      loading: true,
      fullPage: false,
      bgColor: '#fff',
      opacity: 0.5,
      //
      updateArgs: [true, true, true],
      mwOutputSeries: null,
      chartOptions: {
        chart: {
          type: 'spline'
        },
        title: {
          text: 'Sin chart'
        },
        series: [{
          data: [10, 0, 8, 2, 6, 4, 5, 5],
          color: '#6fcd98'
        }]
      }
    };
  }
};
</script>

<style lang="scss" scoped>
#timeseries {
  height: 400px;
  // width: 100%;
  background-color: white;
}

.chart {
  // max-width: 700px;
}

.tab-pane {
  padding: 1rem 1rem 0 0;
}


</style>
